<template>
  <div class="dev-hub-search">
    <form @submit.prevent="onFormSubmit">
      <div class="input-icon">
        <i class="iconmoon-search"></i>
        <input
          v-model="searchVal"
          type="text"
          placeholder="Search..."
          aria-label="search"
          class="input input--md input--dark"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { SEARCH_PAGE_NAME } from "../../router/pageNameConstants";

export default {
  data() {
    return {
      searchVal: ""
    };
  },
  methods: {
    onFormSubmit() {
      const query = this.searchVal.length ? { q: this.searchVal } : {};
      this.$router.push({ name: SEARCH_PAGE_NAME, query });
    }
  }
};
</script>
